export const MIN_PASS_ATTEMPTS = 150;
export const MIN_RUSH_ATTEMPTS = 80;
export const MIN_RECEPTIONS = 40;
